export default __webpack_public_path__ + "static/media/icon-user.e86bacd0.svg";